module.exports = __webpack_public_path__ + "img/Oulabi.a754227b.png";